import { DriverState } from "./driver.type";

export const state: DriverState = {
  drivers: [],
  loading: false,
  driver: null,
  pagination: null
};
